<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
    <h1 class="sr-only">Development Case Studies — Shipped Mobile Apps Across Healthcare, Logistics, Marketplace, and Wellness</h1>
    <app-hero-section height="520px" paddingTop="300px" opacity=".8"
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" [title]="`images/${file}/${file}.svg`"
        text="case studies"></app-hero-section>
    <app-development-projects></app-development-projects>
</app-background>

<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <div class="pt-[200px]">
        <app-info-card>
            <div class="flex flex-col justify-center items-center">
                <div class="font-outfit text-xl sm:text-3xl font-semibold mb-2 sm:mb-6">
                    Why <span class="gradient-text">Semnexus</span>?
                </div>
                <div class="font-inter mb-6 sm:mb-[21px] text-justify text-sm sm:text-base px-[15%]">
                    At Semnexus, we help your app achieve high rankings, increase downloads, and maximize ROI. Our
                    comprehensive app marketing services cover App Store Optimization, competitor analysis, ad copy, and
                    growth strategies tailored for your success. Whether you're launching a new app or scaling an
                    existing
                    one, we deliver high-impact marketing without the high costs. Let's make your app go viral!
                </div>
            </div>
        </app-info-card>
    </div>
    <app-connect></app-connect>
</app-background>